import React, {useMemo} from 'react';
import {touchDevices} from 'shared/Breakpoints';
import styled from 'styled-components';

interface StaticSizeImageProps {
    onError?: () => void;
    onClick?: (event: React.MouseEvent) => void;
    image: string;
    width?: number;
    height?: number;
    inlineSVG?: boolean;
    className?: string;
}

export const StaticSizeImage = ({
    image,
    onError,
    onClick,
    width,
    height,
    inlineSVG = false,
    className,
}: StaticSizeImageProps) => {
    const imageSrc = useMemo(() => {
        if (inlineSVG) {
            return `data:image/svg+xml;base64,${btoa(image)}`;
        }

        return image;
    }, [image, inlineSVG]);

    return (
        <>
            <Image
                onClick={onClick}
                className={`${className || ''} static-image`}
                style={{width: `${width}px`, height: `${height}px`}}
                $src={imageSrc}
            />
            <HiddenImage src={imageSrc} onError={onError} />
        </>
    );
};

const Image = styled.div<{$src: string}>`
    background-image: ${({$src}) => `url("${$src}")`};
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: 50%;
    background-position-y: 50%;

    ${touchDevices`
        background-position: initial;    
    `}
`;

const HiddenImage = styled.img`
    display: none;
`;
